import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
  } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Store } from '@ngxs/store';
  import { Observable } from 'rxjs';
  
  @Injectable({providedIn: 'root'})
  export class HttpDefaultInterceptor implements HttpInterceptor {
      
    constructor(private store: Store) {}
  
    intercept(
      req: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
  
        if (!req.headers.has('skip')) {
            const request = req.clone({
              setHeaders: {
                'content-type': 'application/json',
                accept: 'application/json',
              },
            });
            return next.handle(request);
          }
        
          return next.handle(req);
    }
  }
  